var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-5cc702ff-b51f-4d12-9a65-069d93f5299d",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 855.31 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-e049be35-e20a-455c-aef7-73dc4c85f64b {\r\n        fill: #2c2c2c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e049be35-e20a-455c-aef7-73dc4c85f64b",
    d: "M852.19,259.3c.01-.26.15-.48.15-.74,0-3.08-.78-5.92-2.01-8.54-3.49-9.11-8.53-17.57-15.47-24.5L629.78,20.4h-.03c-8.77-8.73-19.75-13.72-31.36-16.85-3.19-2.05-6.76-3.55-10.82-3.55-1.26,0-2.35.5-3.56.72-1.25-.07-2.36-.72-3.64-.72H69.86C31.34,0,0,31.29,0,69.8v940.34c0,38.51,31.34,69.86,69.86,69.86h715.63c38.51,0,69.83-31.34,69.83-69.86V274.91c0-5.38-1.9-10.43-3.12-15.62ZM789.79,238.15h-144.55c-20.56,0-37.27-16.68-37.27-37.24V56.34l181.82,181.82ZM785.48,1039.2H69.86c-16.02,0-29.06-13.02-29.06-29.06V69.8c0-15.99,13.04-29.01,29.06-29.01h497.32v160.11c0,43.03,35.01,78.04,78.06,78.04h169.28v731.19c0,16.04-13.02,29.06-29.03,29.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e049be35-e20a-455c-aef7-73dc4c85f64b",
    d: "M158.02,373.25h230.64c11.26,0,20.4-9.14,20.4-20.4s-9.14-20.4-20.4-20.4h-230.64c-11.26,0-20.4,9.14-20.4,20.4s9.14,20.4,20.4,20.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e049be35-e20a-455c-aef7-73dc4c85f64b",
    d: "M388.65,878.18h-230.64c-11.26,0-20.4,9.14-20.4,20.4s9.14,20.4,20.4,20.4h230.64c11.26,0,20.4-9.14,20.4-20.4s-9.14-20.4-20.4-20.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e049be35-e20a-455c-aef7-73dc4c85f64b",
    d: "M678.79,741.76H158.02c-11.26,0-20.4,9.14-20.4,20.4s9.14,20.4,20.4,20.4h520.77c11.26,0,20.4-9.14,20.4-20.4s-9.14-20.4-20.4-20.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e049be35-e20a-455c-aef7-73dc4c85f64b",
    d: "M678.79,605.29H158.02c-11.26,0-20.4,9.14-20.4,20.4s9.14,20.4,20.4,20.4h520.77c11.26,0,20.4-9.14,20.4-20.4s-9.14-20.4-20.4-20.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e049be35-e20a-455c-aef7-73dc4c85f64b",
    d: "M678.79,468.87H158.02c-11.26,0-20.4,9.14-20.4,20.4s9.14,20.4,20.4,20.4h520.77c11.26,0,20.4-9.14,20.4-20.4s-9.14-20.4-20.4-20.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.fc16a71aef53a80790906605de29b503.svg";
export { ForwardRef as ReactComponent };